import type { RequestLog } from '../utils/http';
import Account from './Account';
import ApiHttpClient, {
  type ApiClientOptions,
  type Token,
} from './ApiHttpClient';
import Auth from './Auth';
import Bundles from './Bundles';
import Products from './Products';
import Promotions from './Promotions';
import PulseKeys from './PulseKeys';
import Settings from './Settings';
import Users from './Users';
import Utils from './Utils';

export default class PulseApi {
  private readonly client: ApiHttpClient = new ApiHttpClient({
    refreshTokenCallback: async (token) => {
      return this.auth.refreshIdToken(token);
    },
  });

  readonly account = new Account(this.client);
  readonly auth = new Auth(this.client);
  readonly bundles = new Bundles(this.client);
  readonly products = new Products(this.client);
  readonly promotions = new Promotions(this.client);
  readonly pulseKeys = new PulseKeys(this.client);
  readonly settings = new Settings(this.client);
  readonly users = new Users(this.client);
  readonly utils = new Utils(this.client);

  constructor({ token, baseUrl }: ApiClientOptions = {}) {
    this.setToken(token);
    this.client.setBaseUrl(baseUrl);
  }

  setBaseUrl(baseUrl?: string) {
    if (baseUrl) {
      this.client.setBaseUrl(baseUrl);
    }
  }

  setToken(tokens?: Token) {
    this.client.setToken(tokens);
  }

  onTokenRefreshed(callback: (token: Token) => void) {
    this.client.on('token-refreshed', callback);
  }

  onLog(callback: (log: RequestLog) => void) {
    this.client.on('log', callback);
  }
}
